<div class="modal-header">
    <h4 class="modal-title">{{ title | artemisTranslate: titleTranslationParams }}</h4>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title" (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    @if (textIsMarkdown) {
        <div [innerHTML]="text"></div>
    }
    @if (!textIsMarkdown) {
        @if (translateText) {
            <p style="white-space: pre-line">{{ text | artemisTranslate }}</p>
        }
        @if (!translateText) {
            <p style="white-space: pre-line">{{ text }}</p>
        }
    }
    @if (contentRef) {
        <ng-container [ngTemplateOutlet]="contentRef" />
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('cancel click')" jhiTranslate="global.form.cancel"></button>
    <button type="button" ngbAutofocus class="btn btn-danger" (click)="modal.close('Ok click')" jhiTranslate="global.form.confirm"></button>
</div>
